import useMods from '@hooks/useMods';
import PropTypes from 'prop-types';
import React from 'react';

import { twMerge } from "tailwind-merge"

const Divider = ({ mods = {}, className: additionalClassName, variant = 'horizontal', style = 'solid' }) => {
    const { className } = useMods(Divider, { mods: { ...mods, style, variant } }, true);

    return (
        <div className={twMerge(className, additionalClassName)} />
    );
};

Divider.displayName = 'Divider';

Divider.propTypes = {
    mods: PropTypes.object,
    style: PropTypes.string,
    variant: PropTypes.string
};

export default Divider;
